(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-collection-v2"] && !window.DesignMode) return;
  try {
    
$(document).ready(function () {
  // Remove previous instance if it exists
  if ($('.js-collection-v2').hasClass('slick-initialized')) {
    $('.js-collection-v2').slick('unslick');
  }

  // Re-initialize Slick
  $('.js-collection-v2').slick({
    slidesToShow: 4, // Show 3 collections at a time
    slidesToScroll: 1,
    autoplay: false,
  arrows: true,  // Make sure arrows are enabled
    dots: false,
    swipe: true,
    draggable: true,
    touchMove: true,
    infinite: false,
       prevArrow: '<p class="custom-prev">&lt;</p>',
    nextArrow: '<p class="custom-next">&gt;</p>',
    responsive: [
      {
        breakpoint: 1024, // Large tablets
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768, // Tablets
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576, // Mobile
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480, // Smallest screens
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-service-v1"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function () {
      $('.js-services-v1').slick('unslick'); // Destroys the slider
  });

  } catch(e) { console.error(e); }
})();
})();
